import {Injectable, inject} from '@angular/core'
import type {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router'
import {ThemeService} from '@services/theme.service'

@Injectable({
  providedIn: 'root',
})
export class ThemeGuard {
  readonly #themeService = inject(ThemeService)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    this.#themeService.setTheme(0, true)
    return Promise.resolve(true)
  }
}
